function Status({
  transferStatus,
  transferReference,
  transferDetails,
  bankName,
}) {
  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Status</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-body">
            Electricity purchase of{" "}
            <strong>&#8358;{transferDetails.amount}</strong> from your{" "}
            <strong>{transferDetails.wallet_name}</strong>, to{" "}
            <strong>
              {transferDetails.meter_number} | {transferDetails.account_details}
            </strong>
            ,{" "}
            <span
              className={
                transferStatus === "successful" ? "text-primary" : "text-danger"
              }
            >{`${
              transferStatus === "successful"
                ? "was successfully initiated."
                : "has failed to initiate."
            }`}</span>
          </h3>
          {transferReference ? (
            <p className="mb-5 text-secondary">
              Tranfer Reference: {transferReference}
            </p>
          ) : (
            ""
          )}
          <div>
            {transferStatus === "successful" ? (
              <a className="btn btn-primary-soft w-100" href="/dashboard">
                Close
              </a>
            ) : (
              <a className="btn btn-danger-soft w-100" href="/dashboard">
                Close
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Status;
